import clipboard, { DT } from 'clipboard-polyfill';

const escapeHTML = text => text.replace(/<(\/)?((?!hlt).)*?>/g, '');

const countWords = inputString =>
  inputString
    .replace(' - ', ' ')
    .split(' ')
    .filter(n => n !== '').length;

const copyToClipboard = text => {
  const dataTransfer = new DT();
  dataTransfer.setData('text/html', text);
  dataTransfer.setData('text/plain', escapeHTML(text));
  clipboard.write(dataTransfer).then(() => {});
};

export { escapeHTML, countWords, copyToClipboard };
